import Joi from '@hapi/joi'

export const employeeHarvestingJobEditSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Please select valid Group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Please select valid Estate`,
        "any.required": `Estate required`
    }),
    collectionPointID: Joi.number().invalid(0).required().label("Division").messages({
        "any.invalid": `Please select valid Division`,
        "any.required": `Division required`
    }),
    employeeTypeID: Joi.number().invalid(0).required().label("EmployeeTypeID").messages({
        "any.invalid": `Please select valid Employee Type`,
        "any.required": `Employee Type required`
    }),
    jobTypeID: Joi.number().invalid(0).required().label("jobType").messages({
        "any.invalid": `Please select valid Job Type`,
        "any.required": `Job Type required`
    }),
    employeeCode: Joi.string().allow(null, "").alphanum().max(20).label("Employee Code").messages({

        "string.pattern.base": `Please enter valid Employee Code`,
        "string.max": `Please enter {#limit} characters.`
    }),
    fromDate: Joi.string().label("From Date"),
    toDate: Joi.string().label("To Date")
}